import React, { useEffect, useState } from "react";

import axios from 'axios';

import Main from '../components/Home/Main'
import Video from "../components/Home/Video";
import Why from "../components/Home/Why";
import CompcoreProducts from "../components/Home/CompcoreProducts";
import UpgradeToComposite from "../components/Home/UpgradeToComposite";
import Durability from "../components/Home/Durability";
import Areas from "../components/Home/Areas";
import DurabilityStatistics from "../components/Home/DurabilityStatistics";
import Projects from "../components/Home/Projects";
import WhyWait from "../components/Home/WhyWait";
import Zitata from "../components/Home/Zitata";

function Home () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
 
    return(
        <div className="bg-[#1D1D1D] relative overflow-hidden">
            <Main/>
            <Video/>
            <Why/>
            <CompcoreProducts/>
            <UpgradeToComposite/>
            <Durability/>
            <DurabilityStatistics/>
            <Areas/>           
            <Projects/>
            <Zitata/>
            {/* <Liam/> */}
            <WhyWait/>
        </div>
    );
}

export default Home;